import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getCustomer } from '../../../api';

export const coreCustomersCurrentGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreCustomersCurrent',
	receive: true,
	request: false,
	requestHandler: getCustomer
});
